import {Period, Utils} from "revlock-webutils";
import shortid from 'shortid'


export default {
	buildPlan: function buildPlan(startDate, endDate, originalBooking, endDateInclusive = false, calendarConfig) {
		if (Period.isBefore(endDate, startDate)) {
			console.warn(`Plan starts ${startDate} before it ends ${endDate}`);
			return [];
		}

		try {
			const startActgPeriod = Period.toActgPeriod(startDate, calendarConfig);
			const endActgPeriod = Period.toActgPeriod(endDate, calendarConfig);


			let firstPeriodDays;
			if(startActgPeriod.period === endActgPeriod.period) {
				firstPeriodDays =  Period.daysBetween(startDate, endDate, true, endDateInclusive);
			} else {
				firstPeriodDays =  Period.daysBetween(startDate, startActgPeriod.endDate, true, true);
			}


			//if the start and end date are the same period then all revenue goes to the first period

			const lastPeriodDays =
				(startActgPeriod.period === endActgPeriod.period) ? 0 :
					Period.daysBetween(endActgPeriod.startDate, endDate, true, endDateInclusive);


			let periods =
				(startActgPeriod.period === endActgPeriod.period) ? [startActgPeriod.period] :
					Period.periodsBetween(startActgPeriod.period, endActgPeriod.period, true, true);
			//between periods

			const totalContractRevenueDays = (startDate === endDate) ? 1:
				Period.daysBetween(startDate, endDate, true, endDateInclusive);

			if(firstPeriodDays === 0 && lastPeriodDays === 0 && totalContractRevenueDays === 1)
				firstPeriodDays = 1

			const totalPeriods = (startDate === endDate) ? 1:
				periods.length;

			let firstPeriodPercent =
				(firstPeriodDays < 28) ? firstPeriodDays / totalContractRevenueDays: null
			let lastPeriodPercent =
				(lastPeriodDays < 28) ? lastPeriodDays / totalContractRevenueDays: null;

			const remainingPercent = 1 - firstPeriodPercent - lastPeriodPercent;
			let remainingDuration = totalPeriods;
			if(lastPeriodPercent != null && totalPeriods > 1){
				remainingDuration--;
			}
			if(firstPeriodPercent !=null){
				remainingDuration--;
			}

			const monthlyBookingPercent = remainingPercent / remainingDuration;
			//if the percent for first and last period are known already then exclude from duration calcs for remaining

			if(firstPeriodDays >= 28)
				firstPeriodPercent = monthlyBookingPercent;
			if(lastPeriodDays >= 28)
				lastPeriodPercent = monthlyBookingPercent;
			//use a full month if more than 28 days

			const plan = []
			let cumulativeTotal = 0;
			let actgPeriod = startActgPeriod;
			let percentRecognized = 0.0;
			for (let period of periods) {
				let postingDate;
				let planAmount = 0;
				if (period === startActgPeriod.period) {
					actgPeriod = startActgPeriod;
					percentRecognized = firstPeriodPercent;
					planAmount = firstPeriodPercent * originalBooking;

				} else if (period === endActgPeriod.period) {
					actgPeriod = endActgPeriod;
					percentRecognized = lastPeriodPercent;
					planAmount = lastPeriodPercent * originalBooking;

				} else {
					actgPeriod = actgPeriod.get(period)
					planAmount = monthlyBookingPercent * originalBooking;
					percentRecognized = monthlyBookingPercent
				}

				postingDate = actgPeriod.endDate;

				//calculate the amount and dates for the period.

				cumulativeTotal += planAmount;

				plan.push({
					"id": shortid.generate(),
					"actgPeriod": actgPeriod,
					"postingDate": actgPeriod.postingDate,
					"effectiveDate": actgPeriod.endDate,
					"period": actgPeriod.period,
					"postingPeriod": actgPeriod.period,
					"planAmount": planAmount,
					percentRecognized,
					"cummulativePercentRecognized": cumulativeTotal / originalBooking,
					"cummulativeTotal": cumulativeTotal
				})
			}

			return plan;
		} catch (e) {
			throw e;
		}
	}
}

export function updateRatablePlan(plan, originalBooking) {

	// Zero product revenue.
	if (originalBooking == 0) {
		const zeroElement = {
			planAmount: 0,
			percentRecognized: 0,
			cummulativeTotal: 0,
			cummulativePercentRecognized: 0
		}
		plan.forEach(element => {
			Object.assign(element, zeroElement)
		})
		return
	}

	let inv = originalBooking < 0 ? -1 : 1;

	originalBooking = Math.abs(originalBooking)
	let remainingAmount = originalBooking;

	plan.forEach((element, index) => {
		element.planAmount = element.percentRecognized * originalBooking;

		if (element.planAmount > remainingAmount) {
			element.planAmount = remainingAmount;
			element.percentRecognized = (element.planAmount / originalBooking) || 0
		}

		remainingAmount -= element.planAmount;

		// on last element push all remaining amount.
		if (index == plan.length - 1 && !Utils.approxeq(remainingAmount, 0)) {
			element.planAmount += remainingAmount;
			element.percentRecognized = (element.planAmount / originalBooking) || 0
			remainingAmount = 0;
		}

		element.cummulativeTotal = originalBooking - remainingAmount;
		if (originalBooking) {
			element.cummulativePercentRecognized = ((originalBooking - remainingAmount) / originalBooking) || 0;
		}

		element.cummulativeTotal *= inv;
		element.planAmount *= inv;
	});
}